import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './main/main.component';
import { DiplomaComponent } from './diploma/diploma.component';
import { CurriculoComponent } from './curriculo/curriculo.component';
import { BuscaCurriculoComponent } from './curriculo/busca/busca-curriculo.component';

const routes: Routes = [
  { path: 'hed', title: 'Histórico Escolar - Consulta de Documentos Digitais', component: MainComponent },
  { path: 'hed/:id', title: 'Histórico Escolar - Consulta de Documentos Digitais', component: DiplomaComponent },

  { path: 'curriculo', title: 'Currículo Digital - Consulta de Documentos Digitais', component: CurriculoComponent },
  { path: 'curriculo/:id', title: 'Currículo Digital - Consulta de Documentos Digitais', component: BuscaCurriculoComponent },

  { path: '**', pathMatch: 'full', redirectTo: 'hed' }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
